const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      if (input.classList.contains('ml-card-swatch-input')) return;
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()

// Delegation also covers product recommendations and filters inserted after load.
document.addEventListener('change', function (event) {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('.ml-card-swatch-input') || !input.checked) return;
  const card = input.closest('.js-color-swatches-wrapper');
  if (!card) return;
  const link = input.dataset.variantLink;
  if (link) {
    card.querySelectorAll('.js-color-swatches-link, .card__title a, .card-horizontal__title a, .ml-card-product-link').forEach(anchor => { anchor.href = link; });
    card.querySelectorAll('[data-product-url]').forEach(opener => { opener.dataset.productUrl = link; });
  }
  const available = input.dataset.variantAvailable === 'true';
  const button = card.querySelector('.card__add-to-cart button[name="add"]');
  if (button) {
    button.disabled = !available;
    button.setAttribute('aria-disabled', String(!available));
    const text = button.querySelector('span:not(.sold-out-message)');
    const soldOut = button.querySelector('.sold-out-message');
    if (text) text.classList.toggle('hidden', !available);
    if (soldOut) soldOut.classList.toggle('hidden', available);
  }
  const variantInput = card.querySelector('.card__add-to-cart input[name="id"]');
  if (variantInput && input.dataset.variantId) variantInput.value = input.dataset.variantId;
  const image = card.querySelector('.media--first');
  if (image && input.dataset.variantImage) {
    image.removeAttribute('srcset');
    image.src = input.dataset.variantImage;
    image.alt = input.dataset.variantImageAlt || '';
    card.querySelector('.media--second')?.remove();
  }
});
document.addEventListener('error', function (event) {
  if (event.target instanceof HTMLImageElement && event.target.matches('.ml-card-swatch-image')) event.target.hidden = true;
}, true);
